import { Box, BoxProps } from "@mui/material";
import { SectionHeader } from "./SectionHeader";

type ExtensionProps = {
    title?: string;
    divider?: boolean;
    className?: string;
    onDelete?:()=>void;
    onCommand?:()=>void;
    onCommandText?: string;
}

export const SectionBox: React.FC<Partial<BoxProps> & ExtensionProps> = (
    {
        children,
        title,
        divider,
        className,
        onDelete,
        onCommand,
        onCommandText,
        ...rest
    }

) =>
{
    return (

        <>
            <Box {...rest}>
                <SectionHeader 
                    title={title} 
                    divider={divider} 
                    subcard 
                    className={className}
                    onDelete={onDelete}
                    onCommand={onCommand}
                    onCommandText={onCommandText}
                />
            </Box>
            

            {children && (
            <Box sx={{ p: 2 }} {...rest}>
                {children}
            </Box>
            )}
            
        </>

        
    )
}